import type { PortableTextTypeComponent } from '@portabletext/react';

import BaseCallout, { BaseCalloutHtml } from './BaseCallout';

interface Props {
  _type: 'quoteCallout';
  text: string;
  source: string;
}

const QuoteCallout: PortableTextTypeComponent<Props> = ({
  value: { text = '', source = '' } = {},
}) => <BaseCallout text={`"${text}"`} source={source} primary />;

export default QuoteCallout;

export const QuoteCalloutHtml: PortableTextTypeComponent<Props> = ({
  value: { text = '', source = '' } = {},
}) => <BaseCalloutHtml text={`"${text}"`} source={source} primary />;
